import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { Position } from 'coreOld/enums';

interface CenterContainerProps {
  position?: Position;
  children?: ReactNode;
}

interface TooltipContentProps {
  showTooltip?: boolean;
  tooltipOpacity?: number;
  position?: Position;
  backgroundColor?: string;
  children?: ReactNode;
}

export const TooltipWrapper = styled.div`
  position: relative;
  display: inline-flex;
  width: fit-content;
  z-index: 2;
`;

interface TooltipTargetProps {
  children?: ReactNode;
  onMouseEnter?: any;
  onMouseLeave?: any;
}

export const TooltipTarget = styled.span<TooltipTargetProps>`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: inherit;
`;

export const CenterContainer = styled.div<CenterContainerProps>`
  position: absolute;
  width: 200px;
  margin-left: -100px;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 50%;
  bottom: calc(100% + 5px);
  pointer-events: none;
  font-size: inherit;

  ${({ position }) => {
    switch (position) {
      case Position.BOTTOM:
        return css`
          bottom: unset !important;
          top: calc(100% + 5px);
        `;
      case Position.LEFT:
        return css`
          margin-right: 0;
          width: 100%;
          left: unset;
          top: 50%;
          right: calc(100% + 5px);
          width: max-content;
        `;
      case Position.RIGHT:
        return css`
          margin-left: 0;
          width: 100%;
          top: 50%;
          left: calc(100% + 5px);
          width: max-content;
        `;
      default:
        return css`
          bottom: calc(100% + 5px);
        `;
    }
  }}
`;

export const TooltipBox = styled.span<TooltipContentProps>`
  position: relative;
  background-color: rgba(97, 97, 97);
  color: #fff;
  text-align: center;
  border-radius: 5px;
  padding: 4px 8px;
  font-size: 11px;
  opacity: 0;
  z-index: 1;
  transition:
    opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    transform 133ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;

  &:after {
    content: '';
    position: absolute;
    width: 1px;
    height: 1px;
    border-width: 5px;
    border-style: solid;
    border-top-color: ${({ backgroundColor }) =>
      backgroundColor ? backgroundColor : 'rgba(97, 97, 97)'};
    left: calc(50% - 4.5px);
    top: 100%;
  }

  ${({ showTooltip, tooltipOpacity }) => {
    return (
      showTooltip &&
      css`
        opacity: ${tooltipOpacity};

        &:after {
          opacity: ${tooltipOpacity};
        }
      `
    );
  }}

  ${({ position, tooltipOpacity, backgroundColor }) => {
    const color = backgroundColor || `rgba(97, 97, 97, ${tooltipOpacity})`;

    switch (position) {
      case Position.BOTTOM:
        return css`
          &:after {
            border-color: transparent transparent ${color} transparent;
            top: unset;
            width: 1px;
            bottom: 100%;
            left: calc(50% - 5px);
          }
        `;
      case Position.LEFT:
        return css`
          &:after {
            border-color: transparent transparent transparent ${color};
            left: 100%;
            top: calc(50% - 5px);
          }
        `;
      case Position.RIGHT:
        return css`
          &:after {
            border-color: transparent ${color} transparent transparent;
            right: 100%;
            left: unset;
            top: calc(50% - 5px);
          }
        `;
      default:
        return css``;
    }
  }}

  ${({ backgroundColor }) =>
    backgroundColor &&
    css`
      background-color: ${backgroundColor};
    `}
`;
